import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const Play = (props: SvgProps) => (
  <Svg viewBox='0 0 17 19' {...props}>
    <Path
      d='M4 2.4197C4 0.890042 5.64731 -0.0733857 6.98052 0.676544L16.9011 6.25685C18.2604 7.02146 18.2604 8.97854 16.9011 9.74315L6.98052 15.3235C5.64732 16.0734 4 15.11 4 13.5803V2.4197Z'
      fill='currentColor'
    />
  </Svg>
)
